/* eslint-disable typescript-sort-keys/string-enum */
var TrailPageItemsNumber;
(function (TrailPageItemsNumber) {
    TrailPageItemsNumber[TrailPageItemsNumber["ONE"] = 1] = "ONE";
    TrailPageItemsNumber[TrailPageItemsNumber["TWO"] = 2] = "TWO";
    TrailPageItemsNumber[TrailPageItemsNumber["THREE"] = 3] = "THREE";
    TrailPageItemsNumber[TrailPageItemsNumber["FOUR"] = 4] = "FOUR";
    TrailPageItemsNumber[TrailPageItemsNumber["SIX"] = 6] = "SIX";
    TrailPageItemsNumber[TrailPageItemsNumber["TWELVE"] = 12] = "TWELVE";
})(TrailPageItemsNumber || (TrailPageItemsNumber = {}));
export { TrailPageItemsNumber, };
//# sourceMappingURL=trail-constants.js.map